import { render, staticRenderFns } from "./TableContent.vue?vue&type=template&id=7a0060ca&scoped=true&"
import script from "./TableContent.vue?vue&type=script&lang=js&"
export * from "./TableContent.vue?vue&type=script&lang=js&"
import style0 from "./TableContent.vue?vue&type=style&index=0&id=7a0060ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0060ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a0060ca')) {
      api.createRecord('7a0060ca', component.options)
    } else {
      api.reload('7a0060ca', component.options)
    }
    module.hot.accept("./TableContent.vue?vue&type=template&id=7a0060ca&scoped=true&", function () {
      api.rerender('7a0060ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/TableContent.vue"
export default component.exports